import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterCountries',
  pure: false
})
export class FilterCountries implements PipeTransform {
  transform(countries: Array<any>, selectedList: Array<string>, index: number): Array<any> {

    const selectedListFiltered = selectedList.filter((country: any) => country.value !== '');
    selectedListFiltered.splice(index, 1);

    return countries.filter((country: any) => selectedListFiltered.indexOf(country.value) === -1);
  }
}
